<template>
    <div class="bg_grey footer">
        <Map/>
        <div class="footer-content">
            <div class="title">
                <a-divider>联系我们</a-divider>
            </div>
            <p>
                公司电话：{{about.telephoto}}
            </p>
            <p>公司地址：{{about.address}}</p>
        </div>
    </div>
</template>


<script>
import index from './index'
import Map from '../Map/map'
export default {
    ...index,
    components : {
        Map,
    },
}
</script>

<style lang='scss' scoped>

    .footer{
        height: 98.67vw;
        padding: 5.319vw 5.319vw 13.298vw;
        .map{
            width: 100%;
            height: 45.213vw;
        }
       .footer-content{
           .title{
               width: 26.809vw;
               margin: auto;
           }
           p{
               width: 73.138vw;
               margin: auto;
               text-align: center;
               font-size: 3.458vw;
               margin-top: 1.33vw;
           }
       } 
    }

</style>